module.exports = __webpack_public_path__ + "img/banner.da483009.png";